module.exports = __webpack_public_path__ + "img/AdobeStock_87994696.6fccb6f8.jpeg";